module.exports = __webpack_public_path__ + "static/img/gruszok.adf9441e.webp";